/** Sign-out: ghost by default (nav/menus). */
export function getSignOutButtonProps(fullWidth = false) {
  return {
    variant: 'ghost' as const,
    className: fullWidth ? 'w-full justify-start text-muted-foreground' : 'text-muted-foreground',
  };
}

/** Settings page sign-out — outlined, not a solid red block. */
export function getSignOutSettingsButtonProps() {
  return {
    variant: 'outline' as const,
  };
}
